import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { SongItem } from './SongItem';
import * as $ from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-song-item',
  templateUrl: './song-item.component.html',
  styleUrls: ['./song-item.component.scss']
})
export class SongItemComponent implements OnInit {
  url ;
  curent;
  songItem: SongItem;
  constructor(  private http: HttpClient , public sanitizer: DomSanitizer ) {
    var url_string = location.href;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
   }
 
  ngOnInit() {
    $(window).scrollTop(0);
    setTimeout(()=>{
      $('.loaderParent').hide();
    }, 200)
    this.http.get<SongItem>('http://servers.itresources.am/p_n/public/api/music/'+ this.curent).subscribe(data => {
      this.songItem = data;
      // console.log(this.songItem)
    });
   }

}
